// src/components/deviceCatalog.js

export const DEVICE_CATALOG = {
    Hikvision: [
        'DS-K1T804AMF',
        'DS-K1T804BMF',
        'DS-K1T804EF',
        'DS-K1T805MBWX',
        'DS-K1T320MFWX',
        'DS-K1T341AMF',
        'DS-K1T342MFX',
        'DS-K1T343MFWX',
        'DS-K1T671MF',
        'DS-K1T673DX',
        'Diğer',
    ],
    Xpass: [
        'Orion-V1',
        'Orion-Pro',
        'Diğer',
    ],
    Suprema: [
        'BioEntry P2',
        'BioEntry W2',
        'BioStation 2',
        'BioStation 3',
        'FaceStation F2',
        'XPass 2',
        'XPass D2',
        'CoreStation',
        'Diğer',
    ],
    QR: [
        'QR-Konumsuz',
        'QR-Konumlu',
    ],
};

export const PANEL_CATALOG = {
    Hikvision: [
        'DS-K2601T',
        'DS-K2602T',
        'DS-K2604T',
        'DS-K2801',
        'DS-K2802',
        'DS-K2804',
        'DS-K2704X',
        'Diğer',
    ],
    Xpass: [
        'Orion-Panel-4',
        'Diğer',
    ],
};

export const BRAND_LABELS = {
    Hikvision: 'Hikvision',
    Xpass: 'Orion (Xpass)',
    Suprema: 'Suprema',
    QR: 'Mobil QR Cihazı',
};

export const BRAND_META = {
    Hikvision: {
        label: 'Hikvision',
        requiresAuth: true,
        supportsProtocolToggle: true,
        defaultProtocol: 'ISAPI',
        defaultPort: 80,
        defaultHttpsPort: 443,
        defaultSdkPort: 8000,
        supportsIsapiFetch: true,
        supportsReaderSettings: true,
        supportsRelaySettings: true,
        supportsDoorOpen: true,
    },
    Xpass: {
        label: 'Orion (Xpass)',
        requiresAuth: false,
        supportsProtocolToggle: false,
        defaultProtocol: 'UDP',
        defaultPort: 5555,
        supportsIsapiFetch: false,
        supportsReaderSettings: false,
        supportsRelaySettings: true,
        supportsDoorOpen: false,
    },
    Suprema: {
        label: 'Suprema',
        requiresAuth: false,
        supportsProtocolToggle: false,
        defaultProtocol: 'SDK',
        defaultPort: 51211,
        supportsIsapiFetch: false,
        supportsReaderSettings: true,
        supportsRelaySettings: false,
        supportsDoorOpen: false,
    },
    QR: {
        label: 'Mobil QR Cihazı',
        requiresAuth: false,
        supportsProtocolToggle: false,
        defaultProtocol: 'ISAPI',
        defaultPort: 80,
        supportsIsapiFetch: false,
        supportsReaderSettings: false,
        supportsRelaySettings: false,
        supportsDoorOpen: false,
    },
};
